import {
  fetchLtcFinancialPlanningStateByClientIdRequest,
  resetLtcFinancialPlanning,
  selectLtcFinancialPlanningIsLoading,
} from '@client/model';
import { selectLtcFinancialPlanning } from '@client/model/selectors';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export function useLtcFinancialPlanningData(clientId: string | undefined) {
  const dispatch = useDispatch();
  const lastFetchedClientId = useRef<string | null>(null);

  const ltcFinancialPlanningState = useSelector(selectLtcFinancialPlanning);

  const isLoading = useSelector(selectLtcFinancialPlanningIsLoading);

  useEffect(() => {
    if (clientId && lastFetchedClientId.current !== clientId) {
      lastFetchedClientId.current = clientId;
      dispatch(resetLtcFinancialPlanning());
      dispatch(fetchLtcFinancialPlanningStateByClientIdRequest({ clientId }));
    }

    return () => {
      dispatch(resetLtcFinancialPlanning());
    };
  }, [clientId, dispatch]);

  return {
    ltcFinancialPlanningState,
    isLoading,
  };
}
